(() => {
const $562567a2fe1f3149$export$e1252723db1c541 = {
    activeItem: '.anchor-navigation__item.active',
    footer: 'footer.footer',
    header: 'header.header',
    highlightSection: 'section[data-color-scheme="highlight"]',
    item: '.anchor-navigation__item',
    nav: '.anchor-navigation'
};
const $562567a2fe1f3149$export$188d75d71883854a = {
    hide: 'hide',
    show: 'show',
    active: 'active'
};


const $ef19029eced86502$export$99d98991c45140b5 = (el)=>{
    el.classList.remove((0, $562567a2fe1f3149$export$188d75d71883854a).show);
    el.classList.add((0, $562567a2fe1f3149$export$188d75d71883854a).hide);
    $ef19029eced86502$export$456617f45f17a0b1();
};
const $ef19029eced86502$export$58d0df4febc888cf = (el)=>{
    el.classList.remove((0, $562567a2fe1f3149$export$188d75d71883854a).hide);
    el.classList.add((0, $562567a2fe1f3149$export$188d75d71883854a).show);
};
const $ef19029eced86502$export$456617f45f17a0b1 = ()=>{
    let activeItem = document.querySelector((0, $562567a2fe1f3149$export$e1252723db1c541).activeItem);
    activeItem && activeItem.classList.remove((0, $562567a2fe1f3149$export$188d75d71883854a).active);
};
const $ef19029eced86502$export$78fbabf588056ffc = (item)=>{
    // Continue if current nav item is not already active
    if (!item.classList.contains('active')) {
        // Remove active state from other possible item
        $ef19029eced86502$export$456617f45f17a0b1();
        // Add active state to current nav item
        item.classList.add((0, $562567a2fe1f3149$export$188d75d71883854a).active);
    }
};
const $ef19029eced86502$export$2497853127c8bf56 = (container)=>{
    const anchors = [];
    container.querySelectorAll((0, $562567a2fe1f3149$export$e1252723db1c541).item).forEach((el)=>{
        const section = document.querySelector(`#${el.getAttribute('data-target')}`);
        section && anchors.push(section);
    });
    return anchors;
};



const $4911ff9ed25aad73$var$anchorNav = document.querySelector((0, $562567a2fe1f3149$export$e1252723db1c541).nav);
const $4911ff9ed25aad73$var$setHighlightColorScheme = ()=>$4911ff9ed25aad73$var$anchorNav.setAttribute('data-color-scheme', 'highlight');
const $4911ff9ed25aad73$var$removeHighlightColorScheme = ()=>$4911ff9ed25aad73$var$anchorNav.removeAttribute('data-color-scheme');
if ($4911ff9ed25aad73$var$anchorNav) {
    const anchors = (0, $ef19029eced86502$export$2497853127c8bf56)($4911ff9ed25aad73$var$anchorNav);
    const navItemStates = {};
    anchors.forEach((anchor)=>navItemStates[anchor.id] = false);
    // * Initialize IntersectionObserver which observes all sections with a anchor
    const observer = new IntersectionObserver((entries)=>{
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const entryId = entry.target.id;
            if (entry.isIntersecting) navItemStates[entryId] = entry.intersectionRatio;
            else if (navItemStates[entryId] !== false) navItemStates[entryId] = false;
        }
        let maxIntersectionRatio = 0;
        let activeNavItem = false;
        for(let id in navItemStates)if (navItemStates[id] !== false && navItemStates[id] > maxIntersectionRatio) {
            activeNavItem = id;
            maxIntersectionRatio = navItemStates[id];
        }
        activeNavItem ? (0, $ef19029eced86502$export$78fbabf588056ffc)($4911ff9ed25aad73$var$anchorNav.querySelector(`li[data-target="${activeNavItem}"]`)) : (0, $ef19029eced86502$export$456617f45f17a0b1)();
    }, {
        threshold: [
            0,
            0.25,
            0.5,
            0.75,
            1
        ]
    });
    // * Observe elements
    anchors.forEach((anchor)=>observer.observe(anchor));
    // Build a second Observer which is observing all sections
    const highlightSectionObserverCallback = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) entry.intersectionRatio > 0.25 ? $4911ff9ed25aad73$var$setHighlightColorScheme() : $4911ff9ed25aad73$var$removeHighlightColorScheme();
        });
    };
    const colorObserver = new IntersectionObserver(highlightSectionObserverCallback, {
        threshold: [
            0,
            0.25,
            0.5,
            0.75,
            1
        ],
        rootMargin: '-150px 0px -200px 0px'
    });
    document.querySelectorAll((0, $562567a2fe1f3149$export$e1252723db1c541).highlightSection).forEach((section)=>colorObserver.observe(section));
    // Hide anchor navigation when footer comes in viewport
    const footer = document.querySelector((0, $562567a2fe1f3149$export$e1252723db1c541).footer);
    if (footer) {
        const footerObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) (0, $ef19029eced86502$export$99d98991c45140b5)($4911ff9ed25aad73$var$anchorNav);
                else (0, $ef19029eced86502$export$58d0df4febc888cf)($4911ff9ed25aad73$var$anchorNav);
            });
        }, {
            rootMargin: `0px 0px ${-0.5 * window.innerHeight}px 0px`
        });
        footerObserver.observe(footer);
    }
    // Show anchor navigation
    // TODO: Show anchor navigation below header
    $4911ff9ed25aad73$var$anchorNav.classList.add((0, $562567a2fe1f3149$export$188d75d71883854a).show);
}

})();
//# sourceMappingURL=anchor_navigation.min.js.map
